import useSWR from "swr";
import {
  OrganizationService,
  type OrganizationMe,
  type OrgMember,
  type OrgInvitation,
} from "@/services/organization.service";

export function useOrganizationMe() {
  const { data, error, isLoading, mutate } = useSWR<OrganizationMe>(
    "organization-me",
    () => OrganizationService.getMe()
  );

  return {
    me: data,
    isLoading,
    isError: !!error,
    mutate,
  };
}

export function useMembers(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<OrgMember[]>(
    enabled ? "organization-members" : null,
    () => OrganizationService.getMembers()
  );

  return {
    members: data ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
}

export function useInvitations(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<OrgInvitation[]>(
    enabled ? "organization-invitations" : null,
    () => OrganizationService.getInvitations()
  );

  return {
    invitations: data ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
}
